module.exports = __webpack_public_path__ + "static/media/loading_bg.ce893def.gif";